<template>
    <section class="section admin-event-ranking-page">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <h1 class="title">{{ translate("event_ranking.title") }}</h1>
                </div>
            </div>

            <Tabs class="is-boxed" :options="AvailableTabs" v-model="activeTab" />

            <DefineRulesTab v-if="activeTab === AvailableTab.DefineCriteria" />
            <ViewRankingsTab v-else />
        </div>
    </section>
</template>

<script setup lang="ts">
    import { useEventRankingsStore } from "./eventRankingsStore";
    import Tabs from "../Common/Tabs.vue";
    import { ref } from "vue";
    import DefineRulesTab from "./DefineRulesTab.vue";
    import ViewRankingsTab from "./ViewRankingsTab.vue";
    import { translate } from "../Common/translations";

    const props = defineProps<{ eventId: number }>();

    const store = useEventRankingsStore();
    store.eventId = props.eventId;

    const AvailableTab = {
        DefineCriteria: "defineCriteria",
        ViewCriteria: "viewCriteria",
    } as const;

    const AvailableTabs = {
        [AvailableTab.DefineCriteria]: translate("event_ranking.define_criteria"),
        [AvailableTab.ViewCriteria]: translate("event_ranking.view_saved_rankings"),
    } as const;

    const activeTab = ref(AvailableTab.DefineCriteria);
</script>

<style scoped></style>
